import * as React from "react";
const SvgShareMore = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#082B60"
      d="M18 8c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4M18 24c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4M4 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4"
    />
    <path
      fill="#082B60"
      d="M6.361 11.52a1.002 1.002 0 0 1-.496-1.87l9.279-5.289a1 1 0 0 1 1.364.374c.273.479.105 1.09-.374 1.364l-9.28 5.29a1 1 0 0 1-.493.131M15.639 19.77a1 1 0 0 1-.494-.131l-9.279-5.29a1.001 1.001 0 0 1 .99-1.738l9.28 5.29a1.001 1.001 0 0 1-.497 1.87"
    />
  </svg>
);
export default SvgShareMore;
